import * as React from 'react';
import { isFragment } from 'react-is';
export var getFlattenedChildren = function (children) {
    var flatten = function (current) {
        if (!current) {
            return [];
        }
        var result = [];
        React.Children.forEach(current, function (child) {
            if (isFragment(child)) {
                result.push.apply(result, flatten(child.props.children));
            }
            else {
                result.push(child);
            }
        });
        return result;
    };
    return flatten(children).filter(function (child) { return !!child; });
};
//# sourceMappingURL=getFlattenedChildren.js.map